// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"32e29135","977":"5ae227c5"}[chunkId] + ".chunk.js";
};